/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
/* stylelint-disable scss/dollar-variable-colon-space-after */
.display1 {
  font-size: 48px;
  font-weight: normal;
  line-height: 125%;
}
.display1.bold,
.display1 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display1 {
    font-size: 30px;
    line-height: 150%;
  }
}

.display2 {
  font-size: 40px;
  font-weight: normal;
  line-height: 125%;
}
.display2.bold,
.display2 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display2 {
    font-size: 27px;
    line-height: 150%;
  }
}

.display3 {
  font-size: 36px;
  font-weight: normal;
  line-height: 125%;
}
.display3.bold,
.display3 .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .display3 {
    font-size: 24px;
    line-height: 150%;
  }
}

.heading1 {
  font-size: 24px;
  font-weight: normal;
  line-height: 150%;
}
.heading1.bold,
.heading1 .bold {
  font-weight: 600;
}

.heading2 {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.heading2.bold,
.heading2 .bold {
  font-weight: 600;
}

.heading3 {
  font-size: 18px;
  font-weight: normal;
  line-height: 150%;
}
.heading3.bold,
.heading3 .bold {
  font-weight: 600;
}

.heading4 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.heading4.bold,
.heading4 .bold {
  font-weight: 600;
}

.subheading1 {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading2 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.subheading3 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 150%;
  text-transform: uppercase;
}

.body1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.body1.bold,
.body1 .bold {
  font-weight: 600;
}

.body2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
}
.body2.bold,
.body2 .bold {
  font-weight: 600;
}

.body3 {
  font-family: "Red Hat Text", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
}
.body3.bold,
.body3 .bold {
  font-weight: 600;
}

.button1 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.button2 {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 100%;
  text-transform: uppercase;
}

.link1 {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link1.bold,
.link1 .bold {
  font-weight: 600;
}

.link2 {
  font-size: 14px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link2.bold,
.link2 .bold {
  font-weight: 600;
}

.link3 {
  font-size: 12px;
  font-weight: normal;
  line-height: 150%;
  text-decoration-line: underline;
}
.link3.bold,
.link3 .bold {
  font-weight: 600;
}

.small-label1 {
  font-size: 12px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.small-label2 {
  font-size: 10px;
  font-weight: bold;
  line-height: 100%;
  text-transform: uppercase;
}

.cursor-pointer {
  cursor: pointer;
}

.underline {
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.no-text-transform {
  text-transform: none;
}

.gray {
  color: #a6a6a6;
}

.light-gray {
  color: #ccc;
}

.lighter-gray {
  color: #eaeaea;
}

.lightest-gray {
  color: #f5f5f5;
}

.dark-gray {
  color: #767676;
}

.darker-gray {
  color: #606060;
}

.darkest-gray {
  color: #404040;
}

.purple {
  color: #5b1dc2;
}

.dark-purple {
  color: #4b18a1;
}

.white {
  color: #fff;
}

.black {
  color: #000;
}

.red {
  color: #fd868c;
}

.darker-red {
  color: #d43838;
}

.dark-orange {
  color: #ff8313;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.normal {
  font-weight: normal;
}

.InternationalWaitlistBanner {
  align-items: center;
  background: #fdf0c6;
  border: 1px solid #ffd54f;
  border-radius: 8px;
  bottom: 16px;
  display: flex;
  flex-direction: row;
  gap: 40px;
  left: 20px;
  margin: 0 auto;
  max-width: 984px;
  padding: 24px 52px 24px 16px;
  position: fixed;
  right: 20px;
  z-index: 200;
}
@media (max-width: 575.98px) {
  .InternationalWaitlistBanner {
    flex-wrap: wrap;
    gap: 16px;
    left: 8px;
    margin: 0 auto;
    padding: 16px;
    right: 8px;
  }
}

.closeIcon {
  position: absolute;
  right: 8px;
  top: 8px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
}

.title {
  font-size: 20px;
  font-weight: normal;
  line-height: 150%;
}
.title.bold,
.title .bold {
  font-weight: 600;
}
.title {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .title {
    font-size: 18px;
    font-weight: normal;
    line-height: 150%;
  }
  .title.bold,
  .title .bold {
    font-weight: 600;
  }
}

.description {
  font-size: 16px;
  font-weight: normal;
  line-height: 150%;
}
.description.bold,
.description .bold {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .description {
    font-size: 14px;
    font-weight: normal;
    line-height: 150%;
  }
  .description.bold,
  .description .bold {
    font-weight: 600;
  }
}

.cta {
  flex-shrink: 0;
}
@media (max-width: 575.98px) {
  .cta {
    width: 100%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */